/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
.display1 {
  font-size: 48px;
  font-weight: normal;
  line-height: 125%;
}
.display1.bold,
.display1 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display1 {
    font-size: 30px;
    line-height: 150%;
  }
}

.display2 {
  font-size: 40px;
  font-weight: normal;
  line-height: 125%;
}
.display2.bold,
.display2 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display2 {
    font-size: 27px;
    line-height: 150%;
  }
}

.display3 {
  font-size: 36px;
  font-weight: normal;
  line-height: 125%;
}
.display3.bold,
.display3 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display3 {
    font-size: 24px;
    line-height: 150%;
  }
}

.heading1 {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.heading1.bold,
.heading1 .bold {
  font-weight: 600;
}

.heading2 {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.heading2.bold,
.heading2 .bold {
  font-weight: 600;
}

.heading3 {
  font-size: 18px;
  font-weight: normal;
  line-height: 150%;
}
.heading3.bold,
.heading3 .bold {
  font-weight: 600;
}

.heading4 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.heading4.bold,
.heading4 .bold {
  font-weight: 600;
}

.subheading1 {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading2 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading3 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.body1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.body1.bold,
.body1 .bold {
  font-weight: 600;
}

.body2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.body2.bold,
.body2 .bold {
  font-weight: 600;
}

.body3 {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.body3.bold,
.body3 .bold {
  font-weight: 600;
}

.button1 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.button2 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.link1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link1.bold,
.link1 .bold {
  font-weight: 600;
}

.link2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link2.bold,
.link2 .bold {
  font-weight: 600;
}

.link3 {
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link3.bold,
.link3 .bold {
  font-weight: 600;
}

.small-label1 {
  font-size: 12px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.small-label2 {
  font-size: 10px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.cursor-pointer {
  cursor: pointer;
}

.underline {
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.no-text-transform {
  text-transform: none;
}

.gray {
  color: #a6a6a6;
}

.light-gray {
  color: #ccc;
}

.lighter-gray {
  color: #eaeaea;
}

.lightest-gray {
  color: #f5f5f5;
}

.dark-gray {
  color: #767676;
}

.darker-gray {
  color: #606060;
}

.darkest-gray {
  color: #404040;
}

.purple {
  color: #5b1dc2;
}

.dark-purple {
  color: #4b18a1;
}

.white {
  color: #fff;
}

.black {
  color: #000;
}

.red {
  color: #fd868c;
}

.darker-red {
  color: #d43838;
}

.dark-orange {
  color: #ff8313;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.normal {
  font-weight: normal;
}

.InternationalWaitlistBanner {
  align-items: center;
  background: #fdf0c6;
  border: 1px solid #ffd54f;
  border-radius: 8px;
  bottom: 16px;
  display: flex;
  flex-direction: row;
  gap: 40px;
  left: 20px;
  margin: 0 auto;
  max-width: 984px;
  padding: 24px 52px 24px 16px;
  position: fixed;
  right: 20px;
  z-index: 200;
}
@media (max-width: 575.98px) {
  .InternationalWaitlistBanner {
    flex-wrap: wrap;
    gap: 16px;
    left: 8px;
    margin: 0 auto;
    padding: 16px;
    right: 8px;
  }
}

.closeIcon {
  position: absolute;
  right: 8px;
  top: 8px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
}

.title {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.title.bold,
.title .bold {
  font-weight: 600;
}
.title {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .title {
    font-size: 18px;
    font-weight: normal;
    line-height: 150%;
  }
  .title.bold,
  .title .bold {
    font-weight: 600;
  }
}

.description {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.description.bold,
.description .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .description {
    font-size: 14px;
    font-weight: normal;
    line-height: 150%;
  }
  .description.bold,
  .description .bold {
    font-weight: 600;
  }
}

.cta {
  flex-shrink: 0;
}
@media (max-width: 575.98px) {
  .cta {
    width: 100%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */